'use strict';

/**
 * @ngdoc service
 * @name mx.SolutionBuilderAgent.CacheService
 * @module mx.SolutionBuilderAgent
 *
 * @requires {@ref mx.SolutionBuilderAgent.Http mx.SolutionBuilderAgent.Http}
 *
 * @description
 * A service provides methods for managing caches.
 */
CacheService.$inject = ['mx.SolutionBuilderAgent.Http'];
export default function CacheService(http) {
	/**
	 * @ngdoc method
	 * @name mx.SolutionBuilderAgent.CacheService#resetServerCache
	 *
	 * @description
	 * Resets cache on server.
	 *
	 * @param {object} options - Cache reset options. Contains a list of caches to reset.
	 * E.g.
	 * ```
	 * {
	 *    enumeration: true,
	 *    navigation: true,
	 *    action: false,
	 *    widgets: ['809e2f3f-320a-e711-e882-60e327035d39', '809e2f3f-320a-e711-e882-60e327035d37']
	 * }
	 * ```
	 * @returns {promise} resolved to void.
	 */
	function resetServerCache(options) {
		return http.post('api/DataObject/ResetCache', {
			ResetNavigationCache: options.navigation === true,
			ResetActionCache: options.action === true,
			ResetEnumCache: options.enumeration === true,
			ResetWidgetsCache: (typeof options.widgets === 'boolean' && options.widgets) || undefined,
			WidgetIds: (options.widgets && Array.isArray(options.widgets) && options.widgets) || [],
		});
	}

	return {
		resetServerCache: resetServerCache,
	};
}
